import { ImageField, TextAreaField, TextField, ToggleField } from "./SettingsFields";

function AboutPageSettingsForm({ settings, onChange, onFileChange }) {
  return (
    <section className="admin-settings-section">
      <ToggleField label="Enable About page" name="about_page_enabled" checked={settings.about_page_enabled} onChange={onChange} />
      <TextField label="Eyebrow" name="about_eyebrow" value={settings.about_eyebrow} onChange={onChange} />
      <TextField label="Title" name="about_title" value={settings.about_title} onChange={onChange} />
      <TextAreaField label="Intro" name="about_intro" value={settings.about_intro} onChange={onChange} />
      <TextAreaField label="Story" name="about_story" value={settings.about_story} onChange={onChange} />
      <TextField label="Secondary title" name="about_secondary_title" value={settings.about_secondary_title} onChange={onChange} />
      <TextAreaField label="Secondary text" name="about_secondary_text" value={settings.about_secondary_text} onChange={onChange} />
      <ImageField label="About image" name="about_image" value={settings.about_image} clearName="clear_about_image" onChange={onChange} onFileChange={onFileChange} />
      <ImageField label="Secondary image" name="about_secondary_image" value={settings.about_secondary_image} clearName="clear_about_secondary_image" onChange={onChange} onFileChange={onFileChange} />
      <TextField label="CTA title" name="about_cta_title" value={settings.about_cta_title} onChange={onChange} />
      <TextAreaField label="CTA text" name="about_cta_text" value={settings.about_cta_text} onChange={onChange} />
      <TextField label="CTA label" name="about_cta_label" value={settings.about_cta_label} onChange={onChange} />
      <TextField label="CTA URL" name="about_cta_url" value={settings.about_cta_url} onChange={onChange} />
    </section>
  );
}

export default AboutPageSettingsForm;